<div class="flex flex-col">
  <div class="flex flex-col md:flex-row items-center gap-4 portal-actions" *ngIf="!managingOperation">
    <span class="font-semibold branch-section-title">Branch Operations</span>

    <button *ngIf="approved && isEditable" type="button" mat-button color="primary"
      (click)="requestChange(sharedService.add, 0)">Add a Branch</button>

      <button *ngIf="!approved && (isChange || !locked)" type="button" mat-button color="primary"
      (click)="createOperation()">Add a Branch</button>

    <button *ngIf="!isChange" type="button" mat-button color="primary" (click)="getOperations(!includeArchived)">
      {{includeArchived? 'Hide Archived' : 'Show Archived'}}</button>
  </div>

  <div class="flex flex-wrap" *ngIf="!managingOperation" [@slideRight]>
    <div class="md:p-2 w-full" *ngFor="let operation of operations">
      <mat-card class="w-full">
        <mat-card-content>
          <div class="flex flex-col">

            <div class="flex justify-self-end items-center ml-auto portal-actions" [ngClass]="locked? '' : '-mt-4'">
              <span class="font-semibold" *ngIf="operation.archived">Archived</span>
              <button type="button" mat-button color="primary" *ngIf="!operation.archived && !locked" (click)="selectOperation(operation)">Edit</button>
              <button *ngIf="approved && isEditable && !operation.archived" type="button" mat-button color="primary"
                (click)="requestChange(sharedService.change, operation.id)">Change Address</button>
              <button type="button" mat-icon-button [color]="operation.archived? 'primary' : 'warn'" *ngIf="!locked"
                                    (click)="archiveOperation(operation, !operation.archived)"
                                    [matTooltip]="operation.archived? 'Un-Archive Operation' : 'Archive Operation'" matTooltipShowDelay="500"
                                    matTooltipHideDelay="200">
                <mat-icon *ngIf="!operation.archived" fontIcon="archive"></mat-icon>
                <mat-icon *ngIf="operation.archived" fontIcon="unarchive"></mat-icon>
              </button>
            </div>

            <div class="flex flex-row gap-2">
              <span class="md:w-1/4">Phone:</span>
              <span>{{ operation.phone | mask:'000-000-0000' }}</span>
            </div>

            <div class="flex flex-row gap-2">
              <span class="md:w-1/4">Distance to Agency:</span>
              <span *ngIf="operation.distance === 0">Add an address to calculate distance to the agency</span>
              <span *ngIf="operation.distance > 0"
                    [ngClass]="operation.distance < 60? 'text-green-500' : 'text-red-600'">{{ operation.distance }} Miles</span>
            </div>
            <span *ngIf="operation.adding && isRenewal" class="text-green-500">New Branch Added at Renewal</span>
            <span *ngIf="operation.removing && isRenewal" class="text-red-600">Branch Deleted at Renewal</span>
            <span *ngIf="operation.distance >= 60" class="text-red-600">
              This branch appears to be more than 60 miles away from the agency.
              Once the application is approved this branch will be immediately archvied.
              To make an exception for this branch un-archive the branch after approval.
            </span>
            <address class="pt-4"
                     [entityId]="operation.id"
                     [entityType]="sharedService.branchOperation"
                     [limitEntries]="true"
                     [limitTo]="1"
                     [statuses]="statuses"
                     [isChange]="isChange"
                     [isEditable]="isEditable">
            </address>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <div class="flex flex-col gap-4 pt-4" *ngIf="managingOperation" [@slideRight]>
    <mat-card>
      <mat-card-content>
        <div class="flex flex-col">
          <div class="grid grid-cols-2 gap-2 items-center portal-toolbar">
            <div>
              <div *ngIf="managingOperation && operation.id === 0" class="flex flex-col md:flex-row gap-1 portal-detail-row">
                <span class="font-semibold branch-section-title">Add Operation</span>
              </div>

              <div *ngIf="managingOperation && operation.id > 0" class="flex flex-col md:flex-row gap-1 portal-detail-row">
                <span class="font-semibold branch-section-title">Update Operation</span>
              </div>
            </div>
            <div class="gap-2 flex justify-self-end items-center portal-actions">
              <button type="button" *ngIf="managingOperation && operationForm.valid && (!locked || isChange)"
                      mat-button color="primary" (click)="saveOperation()">Save</button>

              <button type="button" *ngIf="managingOperation"
                      mat-button color="warn" (click)="toggleOperationForm(false)">Close</button>
            </div>
          </div>

          <form [formGroup]="operationForm">
            <div class="branch-phone-fields">
              <mat-form-field class="branch-phone-field">
                <mat-label>Phone</mat-label>
                <input matInput formControlName="phone" mask="000-000-0000">
                <mat-error *ngIf="operationForm.get('phone').hasError('required')">
                  A phone number is required
                </mat-error>
                <mat-error *ngIf="operationForm.get('phone').hasError('pattern')">
                  Phone should match format: 000-000-0000
                </mat-error>
              </mat-form-field>
            </div>
          </form>

          <div class="flex flex-row gap-2 pt-4">
            <span>Distance to Agency:</span>
            <span *ngIf="operation.distance === 0">Add an address to calculate distance to the agency</span>
            <span *ngIf="operation.distance > 0"
                  [ngClass]="operation.distance < 60? 'text-green-500' : 'text-red-600'">{{ operation.distance }} Miles</span>
          </div>
          <span *ngIf="operation.distance >= 60" class="text-red-600">
            A branch operation must be fewer than 60 miles from the agency, and
            this branch appears to be more than 60 miles away.
          </span>
          <span *ngIf="operation.distance >= 60 && !isChange" class="text-red-600">
            You may still submit your application, but this branch
            will not be considered for the agency. For questions
            please contact the Health Care Regulation and Quality Improvement Section
            for further assistance.
          </span>
          <address [entityId]="operation.id"
                   [entityType]="sharedService.branchOperation"
                   [limitEntries]="true"
                   [limitTo]="1"
                   [statuses]="statuses"
                   [isChange]="isChange"
                   [isEditable]="isEditable"
                   (updatedPhysicalAddress)="getDistanceToParent()"
                   (reportDistance)="updateLicenseDistance($event, operation)">
          </address>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
